import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { AccountsEntity } from '@nk/data-entities-lib';
import { SelectOptionData } from '@nk/utils-lib';

export type AccountNumberDenomination = 1000 | 1000000 | 1;

export const DENOMINATOR_OPTIONS: SelectOptionData<number, AccountNumberDenomination>[] = [
  {
    key: 1,
    data: 1,
    label: extractTranslation('company.accounts_number_denomination_options.whole_number'),
  },
  {
    key: 2,
    data: 1000,
    label: extractTranslation('company.accounts_number_denomination_options.thousands'),
  },
  {
    key: 3,
    data: 1000000,
    label: extractTranslation('company.accounts_number_denomination_options.millions'),
  },
];
export const DEFAULT_ACCOUNTS_NUMBER_DENOMINATION = DENOMINATOR_OPTIONS[1];

export const CORPORATE_GROUP_ACCOUNTS_ID = 'corporate-group-accounts';

export const YEARS_TO_SHOW = 3;
export const YEARS_TO_SHOW_IN_CHART = 5;
export const LAST_YEARS_TO_SHOW_IN_CHART = 2;

export function getInitialAccountsDenominator(
  accountsNumberDenominationOptions: SelectOptionData<number, AccountNumberDenomination>[],
  localStorageValue?: unknown,
): number {
  if (localStorageValue) {
    const option = accountsNumberDenominationOptions.find((a) => a.data === localStorageValue);
    if (option) {
      return Number(option.key);
    }
  }
  return Number(accountsNumberDenominationOptions[1].key);
}

export function getAccountsYearsSlice(
  accounts: AccountsEntity[],
  sliceOptions: {
    sliceStart: number;
    yearsToShow: number;
  },
): SelectOptionData<number, number[]> | null {
  const slice = accounts.slice(sliceOptions.sliceStart, sliceOptions.sliceStart + sliceOptions.yearsToShow);
  if (slice.length) {
    const startYear = slice[0];
    const endYear = slice[slice.length - 1];
    const label =
      startYear !== endYear
        ? `${startYear.accounting_year} - ${endYear.accounting_year}`
        : `${startYear.accounting_year}`;
    const item: SelectOptionData<number, number[]> = {
      data: slice.map((i) => i.accounting_year),
      key: startYear.accounting_year,
      label: label,
    };
    return item;
  }
  return null;
}

export function getAccountsYearsSlices(
  accounts: AccountsEntity[],
  yearsToShow: number,
): SelectOptionData<number, number[]>[] {
  let count: number;
  if (accounts.length < yearsToShow) {
    count = accounts.length;
  } else {
    count = accounts.length + 1 - yearsToShow;
  }
  const slices: SelectOptionData<number, number[]>[] = [];
  for (let index = 0; index < count; index++) {
    const slice = getAccountsYearsSlice(accounts, { sliceStart: index, yearsToShow });
    if (slice) {
      slices.push(slice);
    }
  }
  return slices;
}
